import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-6" }
const _hoisted_3 = { class: "col-6" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-6" }
const _hoisted_6 = { class: "col-6" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-6" }
const _hoisted_9 = { class: "dialog-footer" }

import { ref, reactive } from "vue";
import type { FormInstance } from "element-plus";
import UserService from "../../../users/services/UserService";
import {
  ConfigAllAccountTypeSelections,
  AccountTypes,
} from "@/core/types/AccountInfos";
import { ConfigBackendCurrencySelections } from "@/core/types/CurrencyTypes";
import { backendConfigLeverageSelections } from "@/core/types/LeverageTypes";
import { ConfigRealServiceSelections } from "@/core/types/ServiceTypes";
import MsgPrompt from "@/core/plugins/MsgPrompt";

export default /*#__PURE__*/_defineComponent({
  __name: 'OpenWholeSaleAccount',
  emits: ["application-submitted"],
  setup(__props, { expose: __expose, emit: emits }) {

const isLoading = ref(false);
const dialogRef = ref(false);
const partyId = ref(0);
const formData = ref<any>({
  referCode: "",
  accountType: AccountTypes.Wholesale,
  currencyId: ConfigBackendCurrencySelections.value.some(
    (currency) => currency.value === 840
  )
    ? 840
    : ConfigBackendCurrencySelections.value[0].value,
  leverage: backendConfigLeverageSelections[0].value,
  serviceId: ConfigRealServiceSelections.value[0].id,
});
const ruleFormRef = ref<FormInstance>();
const rules = reactive<any>({
  //   referCode: [
  //     { required: true, message: "Please input refer code", trigger: "blur" },
  //   ],
  accountType: [
    { required: true, message: "Please select account type", trigger: "blur" },
  ],
  currencyId: [
    { required: true, message: "Please select currency", trigger: "blur" },
  ],
  leverage: [
    { required: true, message: "Please select leverage", trigger: "blur" },
  ],
  serviceId: [
    { required: true, message: "Please select service", trigger: "blur" },
  ],
});



const submit = async () => {
  if (ruleFormRef.value) {
    const valid = await ruleFormRef.value.validate();
    if (!valid) {
      return;
    }
  }
  isLoading.value = true;

  try {
    formData.value.platform = ConfigRealServiceSelections.value.find(
      (item) => item.id === formData.value.serviceId
    )?.platform;
    await UserService.openTradeAccount(partyId.value, formData.value).then(
      () => {
        MsgPrompt.success("Application submitted successfully").then(() => {
          dialogRef.value = false;
          emits("application-submitted");
        });
      }
    );
  } catch (error) {
    MsgPrompt.error("Failed to submit application");
    console.error(error);
  }
  isLoading.value = false;
};
const show = (_partyId) => {
  partyId.value = _partyId;
  dialogRef.value = true;
};
const hide = () => {
  dialogRef.value = false;
  formData.value = {
    referCode: "",
    accountType: AccountTypes.Standard,
    currencyId: ConfigBackendCurrencySelections.value.some(
      (currency) => currency.value === 840
    )
      ? 840
      : ConfigBackendCurrencySelections.value[0].value,
    leverage: backendConfigLeverageSelections[0].value,
    serviceId: ConfigRealServiceSelections.value[0].id,
  };
};

__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogRef.value,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((dialogRef).value = $event)),
    title: _ctx.$t('action.openTradeAccount'),
    width: "800",
    "align-center": "",
    class: "rounded",
    "before-close": hide
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_el_button, {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (dialogRef.value = false)),
          disabled: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit,
          loading: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.confirm")), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        model: formData.value,
        rules: rules,
        "label-position": "top"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_form_item, {
                label: _ctx.$t('fields.referCode'),
                prop: "referCode"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: formData.value.referCode,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.referCode) = $event)),
                    disabled: isLoading.value
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_form_item, {
                label: _ctx.$t('fields.accountType'),
                prop: "accountType"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: formData.value.accountType,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.accountType) = $event)),
                    disabled: true
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ConfigAllAccountTypeSelections), (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_form_item, {
                label: _ctx.$t('fields.currency'),
                prop: "currencyId"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: formData.value.currencyId,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.currencyId) = $event)),
                    disabled: isLoading.value
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ConfigBackendCurrencySelections), (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_el_form_item, {
                label: _ctx.$t('fields.leverage'),
                prop: "leverage"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: formData.value.leverage,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.leverage) = $event)),
                    disabled: isLoading.value
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(backendConfigLeverageSelections), (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }, 8, ["label"])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_el_form_item, {
                label: _ctx.$t('title.service'),
                prop: "serviceId"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: formData.value.serviceId,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.serviceId) = $event)),
                    disabled: isLoading.value
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ConfigRealServiceSelections), (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.label,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }, 8, ["label"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})